// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"366":"2672f8ca","398":"2672f8ca","400":"2672f8ca","465":"2672f8ca","491":"2672f8ca","500":"5d0c0925","742":"2672f8ca","815":"2672f8ca","820":"2672f8ca","920":"2672f8ca"}[chunkId] + ".chunk.css";
};